@if (subMenu || showLeaderFieldModeToolbar) {
  <div [ngClass]="currentMenuPosition === menuPositions.COLLAPSE ? 'collapse' : 'expand'" class="nav-sub-menu">
    @if (subMenu) {
      <div class="entry-menu">
        <div class="menu-title qp-d-flex qp-align-items-center">
          <one-subnav-breadcrumbs></one-subnav-breadcrumbs>
          <div class="margin-left-auto">
            @if (showLeaderFieldModeToolbar) {
              <one-leader-field-mode-button class="leader-field-mode-button"></one-leader-field-mode-button>
            }
            @if (shouldDisplayQuickSearch) {
              <div class="menu-item__quick-search">
                <one-quick-search></one-quick-search>
              </div>
            }
            @if (subMenu.defaultActionRoutes && subMenu.defaultActionRoutes.length > 0) {
              <div class="action-button">
                @if (subMenu.defaultActionRoutes.length > 1 || subMenu.hasActionsDropdown) {
                  <qp-dropdown-nav [buttonLabel]="subMenu.creationButtonLabel" [displayedRoutes]="creationRoutes"></qp-dropdown-nav>
                }
                @if (subMenu.defaultActionRoutes.length === 1 && !subMenu.hasActionsDropdown) {
                  <qima-button
                    [qimaButtonSize]="qimaButtonSizes.SMALL"
                    [qimaButtonStyle]="qimaButtonStyles.PRIMARY"
                    [qimaButtonLabel]="
                      (subMenu.defaultActionRoutes[0].creationButtonLabel
                        ? subMenu.defaultActionRoutes[0].creationButtonLabel
                        : subMenu.creationButtonLabel
                      )
                        | translate
                        | uppercase
                    "
                    [qimaButtonIconName]="
                      subMenu.defaultActionRoutes[0].dataCy === 'create-report-group-btn' ? iconNames.ADD_CIRCLE : undefined
                    "
                    (qimaButtonClick)="onSingleDefaultCreationActionClick()"
                    [attr.data-cy]="subMenu.defaultActionRoutes[0].dataCy"
                    [attr.data-test-id]="subMenu.defaultActionRoutes[0].dataCy"
                  ></qima-button>
                }
              </div>
            }
          </div>
        </div>
        @if (subRoutesDisplayed) {
          <div class="entry-sub-menu">
            @for (subEntity of subMenu.children; track subEntity.routerLink) {
              <div (click)="onSubRouteClick(subEntity)" (keydown.enter)="onSubRouteClick(subEntity)">
                @if (!subEntity.isDefaultAction && subEntity.title) {
                  <a>
                    <span
                      [class.enable]="isDisplayedRouteActive(subEntity.routerLink, subEntity.routerLinkActiveOption.exact)"
                      [routerLink]="subEntity.routerLink"
                      class="submenu-title interactive-1"
                    >
                      {{ subEntity.title | translate }}
                      @if (subEntity.isCounterDisplayed) {
                        ({{ subEntity.counter$ | async }})
                      }
                    </span>
                  </a>
                }
              </div>
            }
          </div>
        }
      </div>
    } @else if (showLeaderFieldModeToolbar) {
      <div class="entry-menu entry-menu--leader-field-mode-only">
        <div class="margin-left-auto">
          <one-leader-field-mode-button class="leader-field-mode-button"></one-leader-field-mode-button>
        </div>
      </div>
    }
  </div>
}
